<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="7.75" y="10.75" width="28.5" height="22.5" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="15.7891" cy="19.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="21.7012" cy="26.5156" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<circle cx="29.8945" cy="17.6445" r="1.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
